import React from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import { useAuth } from "../../util/Auth";
import "./UserHome.css";

export default function UserHome() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isFacilitador = user.roles.includes("facilitador");
  const isAdmin = user.roles.includes("administrator");

  return (
    <div className="user-home-page">
      <TopMenu />

      <main className="user-home-content">
        <section className="hero-card">
          <p className="hero-title">
            {t("pages.userHome.title")}
          </p>
          <p className="hero-subtitle">{t("pages.userHome.subtitle")}</p>
          <p className="hero-description">
            {t("pages.userHome.description")}
          </p>
        </section>

        <section className="action-section">
          <ul className="action-list">
            <li>
              <button
                type="button"
                className="action-button"
                onClick={() => {
                  window.location.href = "/escolha-tipo-inscricao";
                }}
              >
                <span className="action-title">{t("pages.userHome.inscricao")}</span>
                <span className="action-subtitle">
                  {t("pages.userHome.inscricaoSubtitle")}
                </span>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="action-button"
                onClick={() => {
                  window.location.href = "/meus-horarios";
                }}
              >
                <span className="action-title">{t("pages.userHome.meusHorarios")}</span>
                <span className="action-subtitle">
                  {t("pages.userHome.meusHorariosSubtitle")}
                </span>
              </button>
            </li>
            {isFacilitador && (
              <li>
                <button
                  type="button"
                  className="action-button"
                  onClick={() => {
                    window.location.href = "/facilitador-home";
                  }}
                >
                  <span className="action-title">{t("pages.userHome.facilitador")}</span>
                </button>
              </li>
            )}
            {(isFacilitador || isAdmin) && (
              <li>
                <button
                  type="button"
                  className="action-button"
                  onClick={() => {
                    window.location.href = "/cadastros";
                  }}
                >
                  <span className="action-title">{t("pages.userHome.cadastros")}</span>
                </button>
              </li>
            )}
            {isAdmin && (
              <>
                <li>
                  <button
                    type="button"
                    className="action-button"
                    onClick={() => {
                      window.location.href = "/admin-plantoes";
                    }}
                  >
                    <span className="action-title">{t("pages.plantoes.presencialTitle")}</span>
                  </button>
                </li>
                <li>
                  <button
                    type="button"
                    className="action-button"
                    onClick={() => {
                      window.location.href = "/admin-entrevistadores";
                    }}
                  >
                    <span className="action-title">{t("pages.listaEntrevistadores.title")}</span>
                  </button>
                </li>
              </>
            )}
          </ul>
        </section>

        <BottomNav />
      </main>
    </div>
  );
}
